import graphql from 'babel-plugin-relay/macro'
import { useMutation} from 'react-relay'


const mutation = graphql`
  mutation useSubmitErrorFeedbackMutation(
    $errorMessage: String!
    $content: String!
    $eventId: ID!
    $email: String
  ) {
    submitErrorFeedback(
      errorMessage: $errorMessage
      content: $content
      eventId: $eventId
      email: $email
    ) {
      success
    }
  }
`

const useSubmitErrorFeedbackMutation = () => {
  const [commit, submitting] = useMutation(mutation)
  const execute = (config) => {
    return commit({...config})
  }
  return [execute, submitting] 
}

export default useSubmitErrorFeedbackMutation
